import { render } from "./OffersDetails.vue?vue&type=template&id=aec7c0ae"
import script from "./OffersDetails.vue?vue&type=script&lang=js"
export * from "./OffersDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__